import React, { ComponentType } from 'react';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const withDndProvider = <P extends object>(Component: ComponentType<P>) =>
  (props: P) => {
    return (
      <DndProvider backend={HTML5Backend}>
        <Component {...props} />
      </DndProvider>
    );
  };

export default withDndProvider;
